import { render, staticRenderFns } from "./visual.vue?vue&type=template&id=65690b22&scoped=true"
import script from "./visual.vue?vue&type=script&lang=js"
export * from "./visual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65690b22",
  null
  
)

export default component.exports